module.exports = __webpack_public_path__ + "static/img/HTM.ef3c6c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/HTM.png
// module id = B9Ao
// module chunks = 34